var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationMyBills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9994 6.92987V1.33984H2.1393C2.036 1.34113 1.93405 1.36296 1.83925 1.40399C1.74445 1.44503 1.65881 1.50449 1.58717 1.57892C1.51554 1.65334 1.45939 1.74123 1.42201 1.83752C1.38463 1.93382 1.36674 2.03663 1.3694 2.13989V21.7699C1.36674 21.8732 1.38463 21.9759 1.42201 22.0722C1.45939 22.1685 1.51554 22.2564 1.58717 22.3308C1.65881 22.4052 1.74445 22.4647 1.83925 22.5057C1.93405 22.5468 2.036 22.5686 2.1393 22.5699H15.6094C15.8154 22.5621 16.0102 22.474 16.1522 22.3245C16.2942 22.1751 16.3722 21.976 16.3694 21.7699V6.92987H10.9994Z",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.37012V6.93011H16.36L11 1.37012Z",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1898 14.23H3.5498V20.31H14.1898V14.23Z",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5498 17.26H14.1898",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09961 20.3V14.23",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6406 20.3V14.23",
    stroke: "#6A6A6A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationMyBills);
export default __webpack_public_path__ + "static/media/navigation-my-bills.688494d3602cb3d5003020645c764103.svg";
export { ForwardRef as ReactComponent };